// The agent refuses a submitted form field over this many characters, measured after Python's `json.dumps`
// (packages/ai-insights-agent/src/a2ui/form_submissions.py, MAX_SUBMISSION_VALUE_CHARS).
export const MAX_SUBMISSION_VALUE_CHARS = 4000;

const SHORT_ESCAPES = new Set(['"', '\\', '\n', '\r', '\t', '\b', '\f']);

/**
 * The length of `json.dumps(value)` for a string, as the agent measures a submitted field: quoted, with `"`, `\` and
 * control characters escaped, and every non-ASCII UTF-16 code unit written as `\uXXXX` (Python's `ensure_ascii`).
 */
export const measureSubmittedStringLength = (value: string) =>
  2 +
  [...value].reduce((length, character) => {
    if (SHORT_ESCAPES.has(character)) return length + 2;
    const codePoint = character.codePointAt(0) ?? 0;
    if (codePoint < 0x20) return length + 6;
    if (codePoint <= 0x7f) return length + 1;
    // Characters outside the BMP are written as a surrogate pair, two escapes
    return length + 6 * character.length;
  }, 0);

export const exceedsSubmissionValueLimit = (value: string) =>
  measureSubmittedStringLength(value) > MAX_SUBMISSION_VALUE_CHARS;
